function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../../style/pages/valuation/step_1.css";
//@ts-ignore
import { encodeCookie, decodeCookie, removeCookie } from "@utils/CookieUtils";
//@ts-ignore
import PublicUserMenu from "../vue/PublicUserMenu.vue";
import axios from "axios";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import CommonModals from "../vue/CommonComponents/CommonModals";
//@ts-ignore
import { Modals } from "../Types/Modals";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import TrendBanner from "../vue/TrendBanner.vue";
//@ts-ignore
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
//@ts-ignore
import { getPlacesAddressAutocomplete, guessZone } from "@services/geographyAPI";
//@ts-ignore
import { getPlaceFromGAutocomplete } from "@utils/GAutocompleteUtils";
//@ts-ignore
import { CONTRACT } from "@customTypes/ContractEnum";
//@ts-ignore
import { useUtilities } from "@wkComposables/useUtilities";
//@ts-ignore
import { getUserPosition } from "@utils/GeolocationUtils";
//@ts-ignore
import IntersectionObservableVue from "@vueEntry/IntersectionObserver/IntersectionObservableVue.vue";
//@ts-ignore
import IntersectionObserverVue from "@vueEntry/IntersectionObserver/IntersectionObserverVue.vue";
//@ts-ignore
import { reverseGeocoding } from "@services/googleMapsAPI";
import { createApp, defineAsyncComponent } from "vue";
import { mapActions, mapState, createPinia } from "pinia";
import { useLoggedUserStore, usePublicUserMenuStore, useModalStore, useBaseStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useTrustpilotWidget } from "@wkComposables/useTrustpilotWidget";
import { BaseAccordionItem } from "@wikicasa-dev/components";
import "@wikicasa-dev/components/style";
var publicValuationCookie;
var TABTYPE;
(function (TABTYPE) {
  TABTYPE["VALUATE"] = "valuate-tab";
  TABTYPE["SALE"] = "sale-tab";
})(TABTYPE || (TABTYPE = {}));
var step1App = createApp({
  name: "ValuationStep1",
  components: Object.assign(Object.assign({
    IntersectionObservableVue: IntersectionObservableVue,
    IntersectionObserverVue: IntersectionObserverVue,
    BaseAccordionItem: BaseAccordionItem,
    PublicUserMenu: PublicUserMenu,
    TrendBanner: TrendBanner,
    BaseButton: BaseButton,
    BaseAutocomplete: BaseAutocomplete,
    BaseAlert: BaseAlert,
    //@ts-ignore
    cchart: defineAsyncComponent(function () {
      return import("@vueEntry/cchart.vue");
    }),
    //@ts-ignore
    "base-bt-modal": defineAsyncComponent(function () {
      return import("../vue/BaseBtModal.vue");
    }),
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(function () {
      return import("@vueEntry/UIKitComponents/BaseDropDown.vue");
    })
  }, LanguageIcons), CommonModals),
  setup: function setup() {
    var _useAppBanner = useAppBanner(),
      isAppBannerVisible = _useAppBanner.isAppBannerVisible;
    var _useFirebaseMessaging = useFirebaseMessaging(),
      showFirebaseSnackbar = _useFirebaseMessaging.showFirebaseSnackbar,
      snackbarTitle = _useFirebaseMessaging.snackbarTitle,
      snackbarBody = _useFirebaseMessaging.snackbarBody,
      snackbarIcon = _useFirebaseMessaging.snackbarIcon,
      handleOnForegroundNotificationClick = _useFirebaseMessaging.handleOnForegroundNotificationClick;
    var _useUtilities = useUtilities(),
      redirectTo = _useUtilities.redirectTo;
    var _useBreakpoints = useBreakpoints(),
      isLarge = _useBreakpoints.isLarge;
    useTrustpilotWidget();
    return {
      isLarge: isLarge,
      isAppBannerVisible: isAppBannerVisible,
      //useFirebaseMessaging
      showFirebaseSnackbar: showFirebaseSnackbar,
      snackbarTitle: snackbarTitle,
      snackbarBody: snackbarBody,
      snackbarIcon: snackbarIcon,
      handleOnForegroundNotificationClick: handleOnForegroundNotificationClick,
      redirectTo: redirectTo
    };
  },
  data: function data() {
    return {
      disableCb: true,
      hasPlace: false,
      locationBtnDisabled: false,
      writeByUser: undefined,
      writing: false,
      textError: false,
      showUsePositionButton: false,
      valuationNumber: 0,
      lat: 0,
      "long": 0,
      place: JSON.parse(window._place),
      contract: CONTRACT.SALE,
      isPositionRetrievingLoading: false,
      activeTab: TABTYPE.SALE,
      valuationGuideUrl: "https://www.wikicasa.it/news/valutare-casa-online-guida-valutazione-immobile/",
      sellingGuideUrl: "https://www.wikicasa.it/news/come-vendere-casa-privato-agenzia-immobiliare/",
      isSelling: null,
      graphData: [],
      isLoading: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign({
    isDesktop: function isDesktop() {
      return Math.min(window.screen.width, window.screen.height) > 640;
    },
    redirectUrl: function redirectUrl() {
      return window["_redirectURL"];
    },
    valuationAddressInput: function valuationAddressInput() {
      return document.getElementById("field1");
    },
    hasValue: function hasValue() {
      return !!this.writeByUser && this.writing;
    },
    getNumOfValuation: function getNumOfValuation() {
      return Number(window["_valuationCount"]).toLocaleString("it-It", {
        maximumFractionDigits: 2
      });
    },
    labels: function labels() {
      return window["_labels"];
    },
    isValuationActive: function isValuationActive() {
      return this.isActive("valuation-tab");
    },
    isSellingActive: function isSellingActive() {
      return this.isActive("sell-tab");
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])),
  created: function created() {
    this.isSelling = window.fromSale;
    this.initPublicUserMenu();
    if (this.isSelling) this.setActiveTab("sell-tab");else this.setActiveTab("valuation-tab");
  },
  mounted: function mounted() {
    var _a;
    publicValuationCookie = decodeCookie("publicValuationCookie");
    if (window["_invalid"]) this.setShowModal(Modals.valuationNotAvailableModal);
    removeCookie("publicValuationCookie");
    removeCookie("publicValuationRequestCookie");
    if ((_a = this.place) === null || _a === void 0 ? void 0 : _a.placeID) this.initChart(true);
  },
  methods: Object.assign(Object.assign({
    isActive: function isActive(tabElement) {
      return this.activeTab === tabElement;
    },
    setActiveTab: function setActiveTab(tabElement) {
      this.activeTab = tabElement;
    },
    setValuationCookie: function setValuationCookie(realEstateValuation) {
      publicValuationCookie = {
        privateValuation: true,
        realEstateValuation: {
          sale: true,
          cityID: realEstateValuation.cityID,
          macroTypologyID: 1,
          typologyID: 1,
          address: realEstateValuation.address || "",
          streetName: realEstateValuation.streetName,
          latitude: realEstateValuation.latitude,
          longitude: realEstateValuation.longitude
        }
      };
    },
    onInputChangeCb: function onInputChangeCb(query) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (query) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return getPlacesAddressAutocomplete(query, 10);
            case 4:
              res = _context.sent;
              return _context.abrupt("return", res.map(function (r) {
                return {
                  label: r.description,
                  id: r.place_id
                };
              }));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    },
    optionSelectedCb: function optionSelectedCb(selectedEl) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$getPlaceFromGA, place, address;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.disableCb = true;
              _context2.next = 3;
              return getPlaceFromGAutocomplete("".concat(selectedEl.id), selectedEl.label);
            case 3:
              _yield$getPlaceFromGA = _context2.sent;
              place = _yield$getPlaceFromGA.place;
              address = _yield$getPlaceFromGA.address;
              this.locationBtnDisabled = false;
              if (place) {
                _context2.next = 10;
                break;
              }
              this.hasPlace = false;
              return _context2.abrupt("return");
            case 10:
              this.hasPlace = true;
              this.writing = false;
              this.setValuationCookie({
                sale: true,
                cityID: place.cityID,
                address: address,
                streetName: place.streetName,
                latitude: place.latitude,
                longitude: place.longitude
              });
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    },
    submit: function submit() {
      this.isLoading = true;
      publicValuationCookie.realEstateValuation.isSelling = this.isSellingActive;
      encodeCookie("publicValuationCookie", publicValuationCookie);
      window.location.href = window["_nextURL"];
    },
    getCurrentPosition: function getCurrentPosition() {
      var _this = this;
      var _a;
      this.isPositionRetrievingLoading = true;
      (_a = getUserPosition()) === null || _a === void 0 ? void 0 : _a.then(function (res) {
        if (res) {
          _this.lat = res.coords.latitude;
          _this["long"] = res.coords.longitude;
          _this.textError = false;
          _this.retrieveAddressFromCoords(_this.lat, _this["long"]);
        } else {
          _this.textError = true;
        }
      })["catch"](function (error) {
        console.error(error);
        //The user denied Geolocation
        if ((error === null || error === void 0 ? void 0 : error.code) == 1) _this.textError = true;
        _this.isPositionRetrievingLoading = false;
      })["finally"](function () {
        return setTimeout(function () {
          _this.textError = false;
        }, 5000);
      });
    },
    retrieveAddressFromCoords: function retrieveAddressFromCoords(lat, _long) {
      var _this2 = this;
      reverseGeocoding(lat, _long).then(function (reverseRes) {
        //check if the address is in italy if it is not then return
        if (!reverseRes.data || !reverseRes.data.plus_code.compound_code.includes("Italia") && !reverseRes.data.plus_code.compound_code.includes("Italy")) return;
        guessZone(lat, _long).then(function (resGuessZone) {
          var placeN = resGuessZone;
          placeN.address = reverseRes.data.results[0].formatted_address;
          placeN.description = reverseRes.data.results[0].formatted_address;
          _this2.hasPlace = true;
          _this2.writing = false;
          _this2.place = placeN;
          _this2.hasPlace = true;
          _this2.disableCb = true;
          _this2.writeByUser = {
            label: placeN.address
          };
          _this2.setValuationCookie({
            sale: true,
            cityID: placeN.cityID,
            address: placeN.address,
            streetName: placeN.streetName,
            latitude: placeN.latitude,
            longitude: placeN.longitude
          });
        });
      })["catch"]()["finally"](function () {
        _this2.locationBtnDisabled = false;
        _this2.isPositionRetrievingLoading = false;
      });
    },
    openTopCities: function openTopCities(e) {
      this.$refs.containerTopCities.classList.remove("top-cities-collapsed");
      this.$refs.buttonTopCities.classList.remove("d-flex");
      this.$refs.buttonTopCities.classList.add("d-none");
    },
    setContract: function setContract(contract) {
      if (contract == CONTRACT.SALE) {
        this.contract = CONTRACT.SALE;
        this.initChart(true);
      } else if (contract == CONTRACT.RENT) {
        this.contract = CONTRACT.RENT;
        this.initChart(false);
      }
    },
    initChart: function initChart(sale) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return axios.post("/rest/statistics/getValuationPriceGraphData?sale=".concat(sale), this.place);
            case 2:
              res = _context3.sent;
              this.graphData = res.data;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    },
    closeValuationAvailableModal: function closeValuationAvailableModal() {
      this.setShowModal(Modals.noModal);
      history.pushState({}, "", this.redirectUrl);
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(useBaseStore, ["logout", "initPublicUserMenu"]))
});
step1App.use(createPinia());
step1App.mount("#step1-main");